import loadable from '@loadable/component';

export const EditInternshipPageContainerLoadable = loadable(
  () => import('./EditInternshipPageContainer'),
  { resolveComponent: (module) => module.EditInternshipPageContainer },
);
